import { useState, useEffect, useContext } from 'react'
import { QlikUIContext } from '../QlikUIContext'

export function useQlikApp(user, reportId, qlik) {

    const context = useContext(QlikUIContext);
    const [qApp, setqApp] = useState();
    const [selState, setSelState] = useState();
    const [vQVDLoader, setvQVDLoader] = useState('');
    const [vMOD, setvMOD] = useState('');
    const [lastReloadTime, setLastReloadTime] = useState();
    const [loaded, setLoaded] = useState(false);
    
    async function qAppAsync(id) {

      return new Promise((resolve) => {
        const app = qlik.openApp(id,
          {
            host: context.qlikEnvironmentUrl,
            prefix: context.qlikPrefix,
            port: context.qlikPort,
            secure: context.qlikSecure,
            isSecure: context.qlikSecure
          });
          resolve(app);
      });
    }

    function getAppLayout(app) {

      return new Promise((resolve, reject) => {
        app.getAppLayout((layout) => {
          if (layout) {
            resolve(layout);
          } else {
            reject(new Error('Qlik returned an empty app layout'));
          }
        });
      });
    }

    async function reload() {

      return new Promise((resolve, reject) => {
        qAppAsync(vQVDLoader).then((qAppReload) => {
          qAppReload.variable.setStringValue('vMOD', vMOD).then(() => {
            qAppReload.variable.setStringValue('vCOM', user).then(() => {
              qAppReload.doReload().then(function (e) {
                if (e) {
                    qAppReload.doSave().then(() => {
                      reloadAll().then(() => {
                        resolve();
                      }).catch(function(error) {
                        reject(error);
                      })
                    }).catch(function (error) {
                      reject (error);
                      });
                  } else {
                    reject('The report could not be reloaded');
                  }
              }).catch(function (error) {
                reject (error);
              });
            }).catch(function (error) {
              reject (error);
            });;
          }).catch(function (error) {
            reject (error);
          });
        }).catch(function (error) {
          reject (error);
        });
      });
    }

    async function reloadAll() {

      return new Promise((resolve, reject) => {
        qApp.doReload().then(function (e) {
          if (e) {
            qApp.doSave().then(function () {
              qApp.clearAll();
              getAppLayout(qApp).then((layout) => {
                setLastReloadTime(new Date(layout.qLastReloadTime));
                resolve();
              }).catch(function (error) {
                reject (error);
              });
            }).catch(function (error) {
                reject (error);
            });
          } else {
            reject("The report could not be reloaded");
          }
        }).catch(function (error) {
          reject (error);
        });
      });
    }

    async function partialReload() {
      
      return new Promise((resolve, reject) => {
        qApp.doReload(0, true).then(function (e) {
          if (e) {
            qApp.doSave().then(function () {
              getAppLayout(qApp).then((layout) => {
                setLastReloadTime(new Date(layout.qLastReloadTime));
                resolve();
              }).catch(function (error) {
                reject (error);
              });
            }).catch(function (error) {
                reject (error);
            });
          } else {
            reject("The report could not be reloaded");
          }
        }).catch(function (error) {
          reject (error);
        });
      });
    }

    async function setFilters(filters) {

      return new Promise((resolve, reject) => {

        let count = 0;
        filters.forEach(fi => {
          qApp.variable.setStringValue(fi.Var, fi.Value).then((e) => {
              if (e) {
                  count++;
              }

              if (count == filters.length) {
                resolve();
              }
          }).catch(function (error) {
              reject (error);
            });
        });
      });
    }

    useEffect(() => {

      async function loadApp() {

        const app = await qAppAsync(reportId);
        const state = await app.selectionState();

        app.getList('VariableList', function (reply) {
          reply.qVariableList.qItems.forEach(element => {

              console.log(element.qName);
              console.log(element);

              if (element.qName == "vQVDLoader" && element.qDefinition != "") {
                  setvQVDLoader(element.qDefinition);
              }
  
              if (element.qName == "vMOD" && element.qDefinition != "") {
                  setvMOD(element.qDefinition);
              }
          });
        });

        const layout = await getAppLayout(app);

        setLastReloadTime(new Date(layout.qLastReloadTime));
        setSelState(state);
        setqApp(app);
        setLoaded(true);
      }

      loadApp();

      return (() => {
        setqApp(null);
        setSelState(null);
        setLastReloadTime(null);
        setvMOD('');
        setvQVDLoader('');
        setLoaded(false);
      });

    },[reportId]);

    return [ loaded,
      qApp,
      selState, 
      vMOD,
      vQVDLoader,
      lastReloadTime,
      reload,
      reloadAll,
      partialReload,
      setFilters];
  }